<template>
  <div v-if="loading" class="fullscreen-centered">
    Loading...
  </div>
  <div v-else>
    <div>
      <div class="center">
        <div class="border-bottom p2 placed relative">
          <div class="border-none center current-location-label">
            <span @click="changeLocation" class="pointer">{{ location.label }}</span>
            <span @click="changeLocation" class="pointer absolute right-0 pr2">
              <search-icon />
            </span>
          </div>
        </div>
      </div>

      <div v-if="nearbynotes.length === 0" class="fullscreen-centered">Nothing nearby 🌵</div>

      <ul v-else class="list-reset">
        <Preview v-for="(note, index) in nearbynotes" :key="index" :note="note" />
      </ul>

      <div v-if="nearbynotes.length" class="bottom-actions">
        <div v-on:click="loadMore" class="btn btn-outline btn-rounded caps mx-auto" v-bind:class="{ disabled: !showLoadMore }">
          <pulse-loader v-if="loadMoreBusy" :loading="true" :color="'#000000'" :size="'6px'"></pulse-loader>
          <div v-else>Load more</div>
        </div>
      </div>
    </div>

    <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <location-picker v-if="editingLocation" @close="editingLocation = null" @pick="updateLocation"/>
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import globals from '@/globals'
  import { reverseGeo, delay, formatLocation } from '@/util'
  import Preview from '@/components/Preview'
  import LocationPicker from '@/components/LocationPicker'

  export default {
    name: 'Nearby',
    metaInfo: {
      title: 'Field Notes'
    },
    data () {
      return {
        loading: false,
        showLoadMore: true,
        loadMoreBusy: false,
        editingLocation: false,
        location: {
          label: null,
          latitude: null,
          longitude: null
        }
      }
    },
    computed: {
      ...mapState([ 'nearbynotes' ])
    },
    mounted () {
      this.trySetCurrentLocation()
    },
    methods: {
      async refresh () {
        try {
          await this.$store.dispatch('getNearbyNotes', {
            latitude: this.location.latitude,
            longitude: this.location.longitude,
            radius: 10 //km
          })
          if (this.nearbynotes.length < globals.pagination.perPage) {
            this.showLoadMore = false
          }
        } catch (err) {
          throw err
        }
      },
      async loadMore () {
        try {
          this.loadMoreBusy = true
          const before = this.nearbynotes.length
          await this.$store.dispatch('getNextPageOfNearbyNotes', {
            latitude: this.location.latitude,
            longitude: this.location.longitude,
            radius: 10 //km
          })
          const after = this.nearbynotes.length
          const diff = after - before
          if (diff < globals.pagination.perPage) {
            this.showLoadMore = false
          }
          this.loadMoreBusy = false
        } catch (err) {
          this.loadMoreBusy = false
          throw err
        }
      },
      async changeLocation () {
        this.editingLocation = true
      },
      async trySetCurrentLocation () {
        try {
          this.loading = true
          let loc = await this.getDeviceLocation()
          console.log('Location:')
          console.log(loc)


          if (loc) {
            this.location = loc
            await this.refresh()
          }

          this.loading = false
        } catch (err) {
          this.loading = false
        }
      },
      async getDeviceLocation () {
        try {
          const timeoutInterval = 1000
          const timeoutTries = 5
          for (let i = 0; i < timeoutTries; i++) {
            if (this.$store.state.location === null) {
              console.log('Waiting for location...')
              await delay(timeoutInterval)
            } else {
              break
            }
          }

          const deviceLoc = this.$store.state.location

          // // testing: Berlin
          // const deviceLoc = {
          //   coords: {
          //     latitude: 52.52,
          //     longitude: 13.405
          //   }
          // }

          if (deviceLoc) {
            const lat = deviceLoc.coords.latitude
            const lon = deviceLoc.coords.longitude
            const label = await reverseGeo(lat, lon)
            return {
              latitude: lat,
              longitude: lon,
              label: label
            }
          } else {
            console.log('Could not get device location')
            return null
          }
        } catch (err) {
          throw err
        }
      },
      async updateLocation (geo) {
        if (!geo) {
          this.trySetCurrentLocation()
        } else {
          this.location = {
            latitude: parseFloat(geo.lat),
            longitude: parseFloat(geo.lon),
            label: formatLocation(geo.address)
          }

          this.loading = true

          try {
            await this.$store.dispatch('getNearbyNotes', {
              latitude: this.location.latitude,
              longitude: this.location.longitude,
              radius: 10 //km
            })

            this.loading = false
          } catch (err) {
            this.loading = false
            throw err
          }
        }
      },
    },
    components: { Preview, LocationPicker, PulseLoader }
  }
</script>

<style scoped>
.current-location-label {
  font-size: 11px;
  padding: var(--space-1) 0;
}
</style>
